/* eslint-disable import/prefer-default-export */
export const SECOND = 1000
export const VIETNAM_TIME_ZONE = '+07:00'
